import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AgentLogin() {
  const navigate = useNavigate();
  const { status, role, login } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  // Si déjà authentifié comme agent, redirige vers la liste clients
  useEffect(() => {
    if (status === 'authenticated' && role === 'agent') {
      navigate('/agent/clients');
    }
  }, [status, role, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password, 'agent');
      navigate('/agent/clients');
    } catch (err) {
      setError(err.message || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#F5F3F0', display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}>
      <div style={{
        background: '#FDFCFA', borderRadius: 16, padding: '48px 40px',
        border: '1px solid #E0DDD8', width: '100%', maxWidth: 400,
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
      }}>
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#D4724A', marginBottom: 6 }}>Aidly Agent</div>
          <div style={{ fontSize: 14, color: '#8A8A8A' }}>Espace réservé aux agents téléphoniques</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#3A3A3A', marginBottom: 8 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="vous@aidly.fr"
              required
              autoFocus
              autoComplete="email"
              style={{
                width: '100%', padding: '12px 16px', borderRadius: 10,
                border: '1px solid #D9D9D9', fontSize: 16, outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#3A3A3A', marginBottom: 8 }}>
              Mot de passe agent
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              style={{
                width: '100%', padding: '12px 16px', borderRadius: 10,
                border: '1px solid #D9D9D9', fontSize: 16, outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: '10px 14px', borderRadius: 8, background: '#FEE2E2',
              color: '#C0392B', fontSize: 14, marginBottom: 16,
            }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '14px', borderRadius: 10, border: 'none',
            background: loading ? '#D9D9D9' : '#D4724A', color: '#fff',
            fontSize: 16, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
